import image1 from './1-create-enterprise-application.png'
import image2 from './2-create-your-own-application.png'
import image3 from './3-single-sign-on.png'
import image4 from './4-saml-configuration.png'
import image5 from './5-attributes-and-claims.png'
import image6 from './6-app-federation-metadata-url.png'

<details>
<summary>SAML Federation Documentation (click to expand/collapse)</summary>
## SAML Federation Documentation

Flow uses OAuth2 and SAML to provide Single-Sign on capabilities to your enterprise. We use OAuth 2.0 authorization code flow to achieve this. Configuring this in Active Directory is fairly straight forward, an example configuration is shown using ADFS running in Microsoft Azure. Though ADFS in the cloud is presented this configuration should apply to generally any SAML, OAuth 2.0 identity provider (such as Okta).

Launch the [Microsoft Entra Application](https://portal.azure.com/#view/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/~/Overview)

There are just a couple of configuring steps in Microsoft Entra Active Directory to use Flow.

### 1) Create the WorkSight Flow Application
Using Active Directory ENTRA create a new Enterprise application.

<img src={image1} width="600"/>

### 2) Select Create your own Application
Name the application whatever you like. And select "Integrate any other application you don't find in the gallery".

<img src={image2} width="600"/>

### 3) Select the Enterprise Application and then select “Set up single sign on”

Select **SAML** as the single-sign method.

<img src={image3} width="600"/>

### 4) SAML Configuration

For the SAML configuration use the following:

#### Identifier (Entity ID)
```
urn:amazon:cognito:sp:us-west-2_hBTz52iuK
```
#### Reply URL (Assertion Consumer Service URL)
```
https://auth.worksight.services/saml2/idpresponse
```

<img src={image4} width="600"/>

### 5) Attributes and Claims

Map the Active Directory attributes to SAML Claims.

| Claim | Description |
|:---|:---|
| http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name         | The text that will map to the name property of the User       |
| http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress | The text that will map to the email property of the User      |
| http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname    | The text that will map to the first name property of the User |
| http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname      | The text that will map to the last name property of the User  |
| http://schemas.xmlsoap.org/ws/2005/05/identity/claims/groups       | a list of groups that can be mapped into Flow "Roles"         |

Here is an example configuration:

<img src={image5} width="600"/>

### 5) Copy the Metadata URL
Copy the metadata URL from Entra and paste it into the WorkSight Flow Metadata URL field.

<img src={image6} width="600"/>
</details>